module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/aoj_e-2-c5679e61c9571bf63087c95c9a4c64d2.jpg";